//Props Validations
import PropTypes from "prop-types";

// CustomOption Component with PropTypes
const CustomOption = ({ innerRef, innerProps, isDisabled, isFocused, isSelected, children }) => {
    return !isDisabled ? (
        <div
            ref={innerRef}
            {...innerProps}
            style={{
                padding: "8px 12px",
                backgroundColor: isFocused ? "#f8f9fa" : "white",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
            }}
        >
            <input
                type="checkbox"
                checked={isSelected}
                readOnly
                style={{
                    marginRight: "8px",
                    cursor: "pointer",
                }}
            />
            <span className="input-label text-sm">{children}</span>
        </div>
    ) : null;
};

CustomOption.propTypes = {
    innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
    innerProps: PropTypes.object,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    children: PropTypes.node,
};

CustomOption.defaultProps = {
    isDisabled: false,
    isFocused: false,
    isSelected: false,
};

export default CustomOption;
